export default {
    availableTiles({ tiles }, getters) {
        if (getters.selectedAccountId) {
            return tiles.filter(({ type }) => type !== 'inactive');
        }

        return tiles;
    },
};
